import React from 'react';

import { Icon, Typography } from 'wtb-components';
import clsx from 'clsx';
import uiIcons from 'uiIcons';
import styles from './FieldInfo.module.css';

const FieldInfo = (props) => {
  const {
    className,
    text,
    ...other
  } = props;

  return (
    <div className={clsx(styles.root, className)} {...other}>
      <Icon name={uiIcons.info} role="img" aria-hidden="false" />
      <Typography variant="caption">{text}</Typography>
    </div>
  );
};

export default FieldInfo;
